import React from 'react';
import type { IconTextBlockContent } from '../../../types/popup.types';

interface IconTextBlockProps {
  content: IconTextBlockContent;
}

const IconTextBlock: React.FC<IconTextBlockProps> = ({ content }) => {
  const {
    iconColor,
    iconSize,
    title,
    text,
    layout,
    gap,
    align,
    titleColor,
    titleFontWeight,
    titleFontSize,
    textColor,
    textFontWeight,
    textFontSize,
  } = content;

  // Hizalama mapping
  const getJustifyContent = () => {
    switch (align) {
      case 'left':
        return 'flex-start';
      case 'center':
        return 'center';
      case 'right':
        return 'flex-end';
      default:
        return 'flex-start';
    }
  };

  // Layout direction
  const flexDirection = layout === 'vertical' ? 'column' : 'row';

  return (
    <div
      style={{
        display: 'flex',
        justifyContent: getJustifyContent(),
        width: '100%',
        marginBottom: '16px',
      }}
    >
      <div
        style={{
          display: 'inline-flex',
          flexDirection,
          gap: `${gap || 12}px`,
          alignItems: 'center',
        }}
      >
        {/* Announcement.svg İkon */}
        <svg
          width={iconSize || '32'}
          height={iconSize || '32'}
          viewBox="0 0 36 32"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
          style={{ flexShrink: 0 }}
        >
          <path
            d="M18.2352 24.8628C18.21 25.5864 18.0548 26.2917 17.7785 26.9382C17.5023 27.5847 17.1103 28.1599 16.625 28.6309C16.1396 29.1019 15.5705 29.4594 14.9501 29.6831C14.3296 29.9068 13.67 29.9923 13.0088 29.9346C12.3476 29.877 11.6979 29.6774 11.0967 29.3472C10.4956 29.0171 9.95468 28.5628 9.50498 28.0103C9.05529 27.4578 8.70558 26.818 8.47584 26.1274C8.24609 25.4367 8.14081 24.7088 8.166 23.9851M1.99022 17.3758L29.4167 2.11519L34.0198 23.7711L3.141 22.7898L1.99022 17.3758Z"
            stroke={iconColor || '#4285f4'}
            strokeWidth="3"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>

        {/* Metin Alanı */}
        <div>
          <div
            style={{
              color: titleColor || '#212121',
              fontWeight: titleFontWeight || '600',
              fontSize: `${titleFontSize || 13}px`,
            }}
          >
            {title}
          </div>
          <div
            style={{
              color: textColor || '#666666',
              fontWeight: textFontWeight || 'normal',
              fontSize: `${textFontSize || 11}px`,
            }}
          >
            {text}
          </div>
        </div>
      </div>
    </div>
  );
};

export default IconTextBlock;
